/**
 * @desc 查看监控参数曲线图
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ParamMonitorPageRequest,
): Promise<defs.StandardReturn<Array<defs.ParamCurveResponse>>> {
  return defHttp.post({
    url: '/wap/ParamManage/getParamMonitorCurve',
    data,
  });
}

export function mock(
  data: defs.ParamMonitorPageRequest,
): Promise<defs.StandardReturn<Array<defs.ParamCurveResponse>>> {
  return defHttp.post({
    url: '/mock/wap/ParamManage/getParamMonitorCurve',
    data,
  });
}
